export const EDIT_EMPLOYEE_WORK_EMAIL = 'EDIT_EMPLOYEE_WORK_EMAIL'
export const EDIT_EMPLOYEE_WORK_EMAIL_PENDING = 'EDIT_EMPLOYEE_WORK_EMAIL_PENDING'
export const EDIT_EMPLOYEE_WORK_EMAIL_FULFILLED = 'EDIT_EMPLOYEE_WORK_EMAIL_FULFILLED'
export const EDIT_EMPLOYEE_WORK_EMAIL_REJECTED = 'EDIT_EMPLOYEE_WORK_EMAIL_REJECTED'
